import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const LANGUAGE_STORAGE_KEY = 'language';

interface LanguageState {
  value: string;
}

const initialState: LanguageState = {
  value: 'en',
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    getLanguageFromStore: state => {
      const language = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      if (language) {
        state.value = language;
      }
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.value = action.payload;
      localStorage.setItem(LANGUAGE_STORAGE_KEY, action.payload);
    },
  },
});

export const { setLanguage, getLanguageFromStore } = languageSlice.actions;

export const selectLanguage = (state: any) => state.language.value;

export default languageSlice.reducer;
